import { useHasAccess } from "./useHasAccess";
import { useCurrentUserId } from "./useCurrentUserId";
import { routes, useCurrentUrl } from "../lib/urls";

type AdminChatView =
  | { isAdminView: true; userId: string }
  | { isAdminView: false; userId: undefined };

export function useAdminChatView(): AdminChatView {
  const currentUserId = useCurrentUserId();
  const { userId } = useCurrentUrl(routes.chats);
  const hasPermission = useHasAccess("tenant:personal_chats_read");
  if (hasPermission && userId != null && userId !== currentUserId) {
    return { isAdminView: true, userId };
  }
  return { isAdminView: false, userId: undefined };
}
